export enum SyncEventType 
{
    UpdateEntry = "updateentry",
    UpdateEntries = "updateentries"

}